// extracted by mini-css-extract-plugin
module.exports = {"row":"message_row__RjY_a","imageWrap":"message_imageWrap__z0lHa","content":"message_content__jOMIY"};